import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root'
})
export class ConnectionGuard  {
	private router = inject(Router);

	canActivate() {
		return true;
	}
}
